@if (isOpen) {
  <div class="mobile-menu">
    <div class="mobile-menu__header">
      <h2 class="mobile-menu__title">{{ "Menu.Navigation" | translate }}</h2>
      <lwty-button-icon
        icon="x"
        theme="minimal"
        [ariaLabel]="'App.Close' | translate"
        (click)="onClose()"
        (keydown.enter)="onClose()" />
    </div>
    <nav class="mobile-menu__nav">
      <ul class="mobile-menu__sections">
        @for (section of menuItems; track section) {
          <li class="mobile-menu__section">
            @if (section.displayName) {
              <h3 class="mobile-menu__section-title">
                {{ section.displayName | translate }}
              </h3>
            }
            @if (section.children) {
              <ul class="mobile-menu__list">
                @for (item of section.children; track item) {
                  <li
                    class="mobile-menu__item"
                    routerLinkActive="active"
                    [attr.data-testid]="`menu-${item.displayName ?? ''}`">
                    @if (getNavItemUrl(item); as url) {
                      <a
                        class="mobile-menu__link"
                        [routerLink]="url.params"
                        [queryParams]="url.queryParams">
                        @if (item.iconName) {
                          <icon-display
                            [iconName]="item.iconName"
                            [height]="20"
                            [width]="20" />
                        }
                        <span class="mobile-menu__text">
                          {{ item.displayName! | translate }}
                        </span>
                      </a>
                    }
                  </li>
                }
              </ul>
            }
          </li>
        }
      </ul>
    </nav>
  </div>
}
